import { IconFavourite } from 'components/Shared/Icon';
import styles from './styles.scss';
import connect from 'components/Shared/connect';
import { rm } from 'utils';

interface OwnProps {
  favouritesUrl: string;
  numberOfFavourites?: number;
}

export const Favourites = connect<OwnProps>(state => ({
  favouritesUrl: state.appShell.links.favourites,
  numberOfFavourites: state.favourites.productIds.length
}))(({ favouritesUrl, numberOfFavourites }: OwnProps) => {
  const favouritesLabel = rm('favourites_headerbuttonlabel');
  return (
    <div className={styles.favouritesContainer}>
      <a href={favouritesUrl}>
        <div className={styles.favouritesIconAndNumber}>
          <IconFavourite className={styles.favouritesIcon} />
          <span className={styles.number}>{numberOfFavourites}</span>
        </div>
        <span className={styles.label}>{favouritesLabel}</span>
      </a>
    </div>
  );
});
